import { createFileRoute } from "@tanstack/react-router";
import { TicketReport } from "@/features/tickets/TicketReport";

export const Route = createFileRoute("/_authenticated/reports/open-tickets")({
  component: () => (
    <TicketReport
      id="R-45"
      title="Open Tickets"
      description="Tickets that are not yet closed, resolved, or cancelled."
      baseFilters={{ open: true }}
      enabledFilters={["branch", "department", "priority", "source", "coverage", "sla", "dateRange"]}
      filename="open-tickets"
    />
  ),
});

